import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=e2ff4858&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=e2ff4858&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ff4858",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2ff4858')) {
      api.createRecord('e2ff4858', component.options)
    } else {
      api.reload('e2ff4858', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=e2ff4858&scoped=true&", function () {
      api.rerender('e2ff4858', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2OVdrpHunoy1Z/JS/comp/SearchFilterTokens.vue"
export default component.exports